import Features from "@app/feature-flags/features";
import Roles from "@app/user/roles";

export const userCanAccessAIChatPanel = (enabledFeatureFlags: Set<string>, roles: string[]): boolean => {
  if (!enabledFeatureFlags.has(Features.AI_VIRTUAL_ASSISTANT)) {
    return false;
  }
  // The AI Virtual Assistant User can interact with QUINN before GA availability
  if (!enabledFeatureFlags.has(Features.AI_VIRTUAL_ASSISTANT_GA) && !roles.includes(Roles.AI_VIRTUAL_ASSISTANT_USER)) {
    return false;
  }
  return true;
}

/**
 * Gates the legacy Ask Quinn buttons rendered inside Provider Hub. AIAdequacySummary replaces them
 * with the single project-level button in the breadcrumb bar, so the two must never both be visible.
 * Delete this helper and its three call sites when AIAdequacySummary is retired.
 */
export const showLegacyQuinnButtons = (enabledFeatureFlags: Set<string>, roles: string[]): boolean =>
  userCanAccessAIChatPanel(enabledFeatureFlags, roles)
  && !enabledFeatureFlags.has(Features.AI_ADEQUACY_SUMMARY);

/**
 * Chooses how the chat panel presents itself. With AIAdequacySummary on, Quinn is reachable from the
 * breadcrumb bar on every project tab, so it floats over the page as a flyout rather than taking a
 * column from it. Off, it stays the docked rail that narrows the page.
 *
 * Keyed on the flag alone and not on the button's enabled/disabled verdict: `showLegacyQuinnButtons`
 * already guarantees the in-Provider-Hub buttons are suppressed whenever the flag is on, so flag on
 * means the breadcrumb button is the only opener, which means flyout.
 *
 * Inline this as `true` and drop the rail branch when AIAdequacySummary is retired.
 */
export const isQuinnFlyoutLayout = (enabledFeatureFlags: Set<string>): boolean =>
  enabledFeatureFlags.has(Features.AI_ADEQUACY_SUMMARY);